const $ = jQuery.noConflict();

const chooseLanguage = () => {
	// Cache DOM
	const body = $('body');
	const page = body.find('#page');
	const popup = $('.popup');
	const langButton = popup.find('.popup__language-btn label');
	const confirmButton = popup.find('.popup__confirm-btn');
	const langLocal = localStorage.getItem('language');
	const langSession = sessionStorage.getItem('language');
	const urlSession = sessionStorage.getItem('url');
	const homeUrl = popup.attr('data-home-url');
	const homeUrlCurrent = popup.attr('data-home-url-current');

	// Bind events
	// body.addClass('hidden');

	if (langLocal) {
		popup.find(`[data-lang="${langLocal}"]`).prop('checked', 'true');
	}

	if (langSession) {
		popup.remove();
		page.removeClass('display-none');
		// body.removeClass('hidden');
	} else {
		popup.removeClass('display-none');
	}

	if ((homeUrl !== homeUrlCurrent) && !urlSession) {
		window.location.href = homeUrl;
	}

	// Enable confirm button
	langButton.each((i, item) => {
		if ($(item).prev().is(':checked')) {
			confirmButton.removeAttr('disabled');
		}
	});

	langButton.on('click', () => {
		confirmButton.removeAttr('disabled');
	});

	// Redirect to Chosen WPML Page
	confirmButton.on('click', () => {
		const chosenLang = langButton.filter((i, item) => $(item).prev().is(':checked'));
		const chosenLangId = chosenLang.attr('for');

		localStorage.setItem('language', `${chosenLangId}`);
		sessionStorage.setItem('language', `${chosenLangId}`);
		sessionStorage.setItem('url', window.location.href);

		window.location.href = (chosenLangId === 'en') ? homeUrl : chosenLangId;
	});
};

export default chooseLanguage;
